<template>
<div>
    <main>
        <div class="position-relative">
            <!-- Hero for FREE version -->
            <section class="section-hero section-shaped my-0">
                <div class="shape shape-style-1 shape-primary">
                <span class="span-150"></span>
                <span class="span-50"></span>
                <span class="span-50"></span>
                <span class="span-75"></span>
                <span class="span-100"></span>
                <span class="span-75"></span>
                <span class="span-50"></span>
                <span class="span-100"></span>
                <span class="span-50"></span>
                <span class="span-100"></span>
                </div>
                <div class="container shape-container d-flex align-items-center">
                <div class="col px-0">
                    <div class="row justify-content-center align-items-center">
                    <div class="col-lg-7 text-center pt-lg">
                        <img src="assets/img/LogoPR.png" style="width: 300%;" class="img-fluid">
                        <p class="lead text-white mt-4 mb-5">ระบบเช็คการโอนเงินอัตโนมัติ เครื่องมือช่วยขายร้านค้าออนไลน์</p>
                        <div class="btn-wrapper">
                        <a :href="linklinelogin" class="btn btn-white btn-icon mb-3 mb-sm-0">
                            <span class="btn-inner--icon"><i class="fa fa-sign-in"></i></span>
                            <span class="btn-inner--text">เข้าสู่ระบบด้วย Line</span>
                        </a>
                        </div>
                    </div>
                    </div>
                    <div class="row align-items-center justify-content-around stars-and-coded">
                    <div class="col-sm-4">
                        <span class="text-white alpha-7 ml-3">Software Engineering</span>
                    </div>
                    <div class="col-sm-4 mt-4 mt-sm-0 text-right">
                        <span class="text-white alpha-7">Pay Reminder</span>
                    </div>
                    </div>
                </div>
                </div>
            </section>
        </div>

        <section class="section section-lg" id="about">
        <div class="container">
            <div class="row row-grid align-items-center">
            <div class="col-md-6 order-md-2">
                <img src="assets/img/theme/promo-1.png" class="img-fluid floating">
            </div>
            <div class="col-md-6 order-md-1">
                <div class="pr-md-5">
                <h3>เกี่ยวกับ</h3>
                <p>ระบบเช็คการโอนเงิรอัตโนมัติ ได้มีการใช้ System development Life Cycle (SDLC) ประเภท Agile เข้ามาช่วยในการจัดการขั้นตอนของการทำงาน โดยมีขั้นตอนการดำเนินงานดังนี้</p>
                <ul class="list-unstyled mt-5">
                    <li class="py-2">
                    <div class="d-flex align-items-center">
                        <div>
                        <h6 class="mb-0"><img src="https://services.payremind.com/assets/images/icon/analysis.png" style="width: 10%;">&nbsp;&nbsp;&nbsp;REQUIREMENT ANALYSIS AND DEFINITION</h6>
                        </div>
                    </div>
                    </li>
                    <li class="py-2">
                    <div class="d-flex align-items-center">
                        <div>
                        <h6 class="mb-0"><img src="https://services.payremind.com/assets/images/icon/workspace.png" style="width: 10%;">&nbsp;&nbsp;&nbsp;SYSTEM AND SOFTWARE DESIGN</h6>
                        </div>
                    </div>
                    </li>
                    <li class="py-2">
                    <div class="d-flex align-items-center">
                        <div>
                        <h6 class="mb-0"><img src="https://services.payremind.com/assets/images/icon/coding.png" style="width: 10%;">&nbsp;&nbsp;&nbsp;IMPLEMENTATION AND UNIT TESTING</h6>
                        </div>
                    </div>
                    </li>
                    <li class="py-2">
                    <div class="d-flex align-items-center">
                        <div>
                        <h6 class="mb-0"><img src="https://services.payremind.com/assets/images/icon/malware.png" style="width: 10%;">&nbsp;&nbsp;&nbsp;INTEGRATION AND SYSTEM TESTING</h6>
                        </div>
                    </div>
                    </li>
                </ul>
                </div>
            </div>
            </div>
        </div>
        </section>
        
        <section class="section bg-secondary">
        <div class="container">
            <div class="row row-grid align-items-center">
            <div class="col-md-6">
                <div class="card bg-default shadow border-0">
                <iframe style="width:100%;height: 400px;" src="https://www.youtube.com/embed/W1JE_YEV6k0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen="" class="card-img-top"></iframe>
                </div>
            </div>
            <div class="col-md-6">
                <div class="pl-md-5">
                <h3>ทำไมต้องใช้กับเรา</h3>
                <p class="lead">ลดปัญหาค่าธรรมเนียมการชำระเงินแต่ละครั้งและลดระยะเวลาในการตรวจเช็คหลักฐานการชำระเงินในแต่ละครั้ง โดยผู้ซื้อสินค้าจะได้ประหยัดค่าใช้จ่ายในส่วนนี้และเป็นการช่วยผู้ขายให้มีเวลาว่างในการทำกิจกรรมอย่างอื่นมากขึ้นอีกด้วย</p>
                <p>
                    <ul class="font-weight-bold text-warning">
                        <li>เพื่อแก้ปัญหาการเสียค่าธรรมเนียมของผู้ซื้อ</li>
                        <li>เพื่อลดความล่าช้าในการได้รับสินค้าของผู้ซื้อ</li>
                        <li>เพื่อให้ผู้ซื้อและผู้ขายไม่จำเป็นต้องมีบัญชีหลายธนาคาร</li>
                        <li>เพื่อให้ผู้ขายไม่ต้องเสียเวลาเช็คหลักฐานการโอนเงิน</li>
                        <li>เพื่อทำให้เกิดความสะดวกทั้งกับร้านค้าและลูกค้า</li>
                    </ul>
                </p>
                </div>
            </div>
            </div>
        </div>
        </section>
        
        <section class="section section section-shaped my-0 overflow-hidden" id="award">
        <div class="shape shape-style-1 bg-gradient-warning shape-skew">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container py-0">
            <div class="row row-grid align-items-center">

            <div class="col-lg-12">
                <div class="d-flex px-3">
                <div>
                    <div class="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-primary">
                    <i class="ni ni-image text-primary"></i>
                    </div>
                </div>
                <div class="pl-4">
                    <h4 class="display-3 text-white">ผลงาน</h4>
                    <p class="text-white">ผลงานและรางวัลที่ได้รับ</p>
                </div>
                </div>
            </div>

            <!-- start photo -->
            <div class="col-lg-4 order-lg-1">
                <div class="card shadow shadow-lg--hover mt-5">
                <div class="card-body">
                    <div class="d-flex px-3">
                    <div class="pl-2">
                        <h5 class="title text-primary">StrartUp 2017</h5>
                        <p>ได้รับรางวัลสนับสนุนโครงการ 100,000 บาท</p>
                        <img src="https://services.payremind.com/assets/images/Portfolio/Startup_2017.jpg" style="width:100%;" alt="">
                        <a href="https://services.payremind.com/assets/images/Portfolio/Startup_2017.jpg" target="_blank" class="text-primary">ดูภาพเต็ม</a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <!-- end photo -->
            <!-- start photo -->
            <div class="col-lg-4 order-lg-1">
                <div class="card shadow shadow-lg--hover mt-5">
                <div class="card-body">
                    <div class="d-flex px-3">
                    <div class="pl-2">
                        <h5 class="title text-primary">StrartUp 2018</h5>
                        <p>ได้รับรางวัลสนับสนุนโครงการ 50,000 บาท</p>
                        <img src="https://services.payremind.com/assets/images/Portfolio/Startup_2018.jpg" style="width:100%;" alt="">
                        <a href="https://services.payremind.com/assets/images/Portfolio/Startup_2018.jpg" target="_blank" class="text-primary">ดูภาพเต็ม</a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <!-- end photo -->
            <!-- start photo -->
            <div class="col-lg-4 order-lg-1">
                <div class="card shadow shadow-lg--hover mt-5">
                <div class="card-body">
                    <div class="d-flex px-3">
                    <div class="pl-2">
                        <h5 class="title text-primary">ACM ICPC 2016</h5>
                        <p>ได้รับรางวัล 20,000 บาท และไปแข่งขันต่อระดับประเทศ</p>
                        <img src="https://services.payremind.com/assets/images/Portfolio/acm.jpg" style="width:100%;" alt="">
                        <a href="https://services.payremind.com/assets/images/Portfolio/acm.jpg" target="_blank" class="text-primary">ดูภาพเต็ม</a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <!-- end photo -->
            <!-- start photo -->
            <div class="col-lg-4 order-lg-1">
                <div class="card shadow shadow-lg--hover mt-5">
                <div class="card-body">
                    <div class="d-flex px-3">
                    <div class="pl-2">
                        <h5 class="title text-primary">StrartUp 2018</h5>
                        <p>ทีมงาน</p>
                        <img src="https://services.payremind.com/assets/images/Portfolio/stl1.jpg" style="width:100%;" alt="">
                        <a href="https://services.payremind.com/assets/images/Portfolio/stl1.jpg" target="_blank" class="text-primary">ดูภาพเต็ม</a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <!-- end photo -->
            <!-- start photo -->
            <div class="col-lg-4 order-lg-1">
                <div class="card shadow shadow-lg--hover mt-5">
                <div class="card-body">
                    <div class="d-flex px-3">
                    <div class="pl-2">
                        <h5 class="title text-primary">StrartUp 2018</h5>
                        <p>ทีมงานขณะนำเสนอโครงการ</p>
                            <img src="https://services.payremind.com/assets/images/Portfolio/stl2.jpg" style="width:100%;height: 158px;" alt="">
                            <a href="https://services.payremind.com/assets/images/Portfolio/stl2.jpg" target="_blank" class="text-primary">ดูภาพเต็ม</a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <!-- end photo -->
            <!-- start photo -->
            <div class="col-lg-4 order-lg-1">
                <div class="card shadow shadow-lg--hover mt-5">
                <div class="card-body">
                    <div class="d-flex px-3">
                    <div class="pl-2">
                        <h5 class="title text-primary">StrartUp 2018</h5>
                        <p>ทีมงาน</p>
                        <img src="https://services.payremind.com/assets/images/Portfolio/stl3.jpg" style="width:100%;" alt="">
                        <a href="https://services.payremind.com/assets/images/Portfolio/stl3.jpg" target="_blank" class="text-primary">ดูภาพเต็ม</a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            <!-- end photo -->
            
            </div>
        </div>
        </section>

        
        <section class="section section-lg" id="developer">
        <div class="container">
            <div class="row justify-content-center text-center mb-lg">
            <div class="col-lg-8">
                <h2 class="display-3">ทีมงาน</h2>
                <p class="lead text-muted">ทีมงานและผู้ก่อตั้งบริษัท Pay Reminder</p>
            </div>
            </div>
            <div class="row">
            <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                <div class="px-4">
                <img src="https://services.payremind.com/assets/images/team/Pee.jpg" class="rounded img-center img-fluid shadow shadow-lg--hover" style="width: 200px;">
                <div class="pt-4 text-center">
                    <h5 class="title">
                    <span class="d-block mb-1">พีรพัฒน์ มาเที่ยง</span>
                    <small class="h6 text-muted">CEO & WEB DEVELOPER</small>
                    </h5>
                    <div class="mt-3">
                    <a href="#" class="btn btn-warning btn-icon-only rounded">
                        <i class="fa fa-twitter"></i>
                    </a>
                    <a href="#" class="btn btn-warning btn-icon-only rounded">
                        <i class="fa fa-facebook"></i>
                    </a>
                    <a href="#" class="btn btn-warning btn-icon-only rounded">
                        <i class="fa fa-dribbble"></i>
                    </a>
                    </div>
                </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                <div class="px-4">
                <img src="https://services.payremind.com/assets/images/team/Ta.jpg" class="rounded img-center img-fluid shadow shadow-lg--hover" style="width: 200px;">
                <div class="pt-4 text-center">
                    <h5 class="title">
                    <span class="d-block mb-1">นันทวัฒน์ บุญศรีภูมิ</span>
                    <small class="h6 text-muted">CTO & UI/UX Designer</small>
                    </h5>
                    <div class="mt-3">
                    <a href="#" class="btn btn-primary btn-icon-only rounded">
                        <i class="fa fa-twitter"></i>
                    </a>
                    <a href="#" class="btn btn-primary btn-icon-only rounded">
                        <i class="fa fa-facebook"></i>
                    </a>
                    <a href="#" class="btn btn-primary btn-icon-only rounded">
                        <i class="fa fa-dribbble"></i>
                    </a>
                    </div>
                </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                <div class="px-4">
                <img src="https://services.payremind.com/assets/images/team/Silk.jpg" class="rounded img-center img-fluid shadow shadow-lg--hover" style="width: 200px;">
                <div class="pt-4 text-center">
                    <h5 class="title">
                    <span class="d-block mb-1">ชนิสรา ใจมา</span>
                    <small class="h6 text-muted">MARKETING</small>
                    </h5>
                    <div class="mt-3">
                    <a href="#" class="btn btn-info btn-icon-only rounded">
                        <i class="fa fa-twitter"></i>
                    </a>
                    <a href="#" class="btn btn-info btn-icon-only rounded">
                        <i class="fa fa-facebook"></i>
                    </a>
                    <a href="#" class="btn btn-info btn-icon-only rounded">
                        <i class="fa fa-dribbble"></i>
                    </a>
                    </div>
                </div>
                </div>
            </div>
            <div class="col-md-6 col-lg-3 mb-5 mb-lg-0">
                <div class="px-4">
                <img src="https://services.payremind.com/assets/images/team/Davit.jpg" class="rounded img-center img-fluid shadow shadow-lg--hover" style="width: 200px;">
                <div class="pt-4 text-center">
                    <h5 class="title">
                    <span class="d-block mb-1">ดวิษ แสนโภชน์</span>
                    <small class="h6 text-muted">CONSULTANTS</small>
                    </h5>
                    <div class="mt-3">
                    <a href="#" class="btn btn-success btn-icon-only rounded">
                        <i class="fa fa-twitter"></i>
                    </a>
                    <a href="#" class="btn btn-success btn-icon-only rounded">
                        <i class="fa fa-facebook"></i>
                    </a>
                    <a href="#" class="btn btn-success btn-icon-only rounded">
                        <i class="fa fa-dribbble"></i>
                    </a>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>

        <section class="section section-shaped my-0 overflow-hidden" id="contact">
        <div class="shape shape-style-3 bg-gradient-default shape-skew">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg pb-300">
            <div class="row text-center justify-content-center">
            <div class="col-lg-10">
                <h2 class="display-3 text-white">ติดต่อ</h2>
                <p class="lead text-white">หากคุณมีคำถามหรือต้องการความช่วยเหลือกรุณาติดต่อเรา เรายินดีทำเพื่อคุณ</p>
            </div>
            </div>
        </div>
        </section>
        <section class="section section-lg pt-lg-0 section-contact-us">
        <div class="container">
            <div class="row justify-content-center mt--300">
            <div class="col-lg-8">
                <div class="card bg-gradient-secondary shadow">
                <div class="card-body p-lg-5">
                    <h4 class="mb-1">ส่งข้อความถึงผู้ดูแลระบบ</h4>
                    <p class="mt-0">กรุณาระบุข้อมูลที่สามารถติดต่อกลับได้</p>
                    <div class="form-group mt-5">
                    <div class="input-group input-group-alternative">
                        <div class="input-group-prepend">
                        <span class="input-group-text"><i class="ni ni-user-run"></i></span>
                        </div>
                        <input class="form-control" placeholder="Your name" type="text">
                    </div>
                    </div>
                    <div class="form-group">
                    <div class="input-group input-group-alternative">
                        <div class="input-group-prepend">
                        <span class="input-group-text"><i class="ni ni-email-83"></i></span>
                        </div>
                        <input class="form-control" placeholder="Email address" type="email">
                    </div>
                    </div>
                    <div class="form-group mb-4">
                    <textarea class="form-control form-control-alternative" name="name" rows="4" cols="80" placeholder="Type a message..."></textarea>
                    </div>
                    <div>
                    <button type="button" class="btn btn-default btn-round btn-block btn-lg">Send Message</button>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>

        <!-- <section class="section section-lg">
        <div class="container">
            <div class="row row-grid justify-content-center">
            <div class="col-lg-8 text-center">
                <h2 class="display-3">พันธมิตรของเรา</h2>
                <p class="lead text-success">พันธมิตรที่ช่วยให้การทำงานของเราดำเนินต่อไปได้ในความสะดวกสบายของผู้ใข้</p>
                <div class="text-center">
                <h4 class="display-4 mb-5 mt-5">ขอบคุณ</h4>
                <div class="row justify-content-center">

                    <div class="col-lg-3">
                    <a href="#" target="_blank" data-toggle="tooltip" data-original-title="Truemoney Wallet">
                        <img src="https://services.payremind.com/assets/images/icon/tw.png" style="width:70%;height:85px;" class="img-fluid">
                    </a>
                    </div>
                    <div class="col-lg-3">
                    <a href="#" target="_blank" data-toggle="tooltip" data-original-title="KTB">
                        <img src="https://services.payremind.com/assets/images/icon/ktb.jpg" style="width:100%;height:85px;" class="img-fluid">
                    </a>
                    </div>
                    <div class="col-lg-3">
                    <a href="#" data-toggle="tooltip" data-original-title="SCB">
                        <img src="https://services.payremind.com/assets/images/icon/scb.jpg" style="width:100%;height:85px;" class="img-fluid ">
                    </a>
                    </div>
                    <div class="col-lg-3">
                    <a href="#" target="_blank" data-toggle="tooltip" data-original-title="UP">
                        <img src="https://services.payremind.com/assets/images/icon/up_logo.png" style="width:50%;height:85px;" class="img-fluid">
                    </a>
                    </div>
                    
                </div>
                </div>
            </div>
            </div>
        </div>
        </section> -->


    </main>
</div>
</template>

<script>
import UserStore from '@/stores/UserStore'
export default {
  name: 'Home',
  components: {
    // HelloWorld
  },
  data(){
      return {
          linklinelogin:null,
          urlLogo: '../assets/img/LogoPR.png'
      }
  },
  methods: {
    LoadLinklinelogin: async function() {
      await UserStore.dispatch('getLoginLine')
      if(UserStore.state.lineloginline.status){ 
        this.linklinelogin = UserStore.state.lineloginline.url;
      }
    },

  },
  async mounted () {
    await this.LoadLinklinelogin()
    // console.log(this.linklinelogin);
  },
}
</script>